import { IAuthorizationWithCrosses } from '../types';
import { computeAuthorizationBalances } from './authorizationBalances';

export interface AuthorizationRefundImpact {
	authorizationId: number;
	totalRefunded: number;
	isFullyRefunded: boolean;
}

export const getAuthorizationRefundImpacts = (
	authorizations: IAuthorizationWithCrosses[],
): AuthorizationRefundImpact[] =>
	authorizations
		.map((authorization) => {
			const balances = computeAuthorizationBalances(authorization);
			if (balances.totalRefunded <= 0) return null;
			return {
				authorizationId: authorization.id,
				totalRefunded: balances.totalRefunded,
				isFullyRefunded: balances.isFullyRefunded,
			};
		})
		.filter((impact): impact is AuthorizationRefundImpact => impact !== null);

export const getTotalRefundedReleasedToTransaction = (authorizations: IAuthorizationWithCrosses[]): number =>
	getAuthorizationRefundImpacts(authorizations).reduce((sum, impact) => sum + impact.totalRefunded, 0);
